<template>
  <div>
    <el-container class="container">
      <el-aside width="100%">
        <h2>{{routeTitle.substring(0, routeTitle.length - 2)}}分类</h2>
        <el-menu
          unique-opened
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          mode="vertical"
          @select="activaSelect"
          @open="handleOpen"
          @close="handleClose">
          <el-menu-item :index="(item.catid).toString()" v-for="(item,index) in leftMenu.navList" :key="index">
            <img src="@/assets/navbar.png" alt="">
            <span>{{item.catname}}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

    </el-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leftMenu: {
          navList: []
        }

      }
    },
    mounted() {
      this.initNavList();
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      activaSelect(key, keyPath){
        //发送catid到material父组件
        this.$emit('itemfun',key)
      },
      initNavList(){
        this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=additive_cate').then(resp=>{
          if(resp){
            this.leftMenu.navList = resp.data.data;
            this.leftMenu.navList.catid = resp.data.data.catid;
            console.log(resp);
          }
        })
      }
    },
    created () {
      // 接收header导航传过来的name
      this.routeTitle = this.$route.query.name;
    },
  }
</script>

<style scoped>
h2 {
  padding: 0 20px;
}
.el-aside {
  overflow: initial;
  background-color: #fff;
}
.el-menu{
  border: 0;
}
.el-menu-item, .el-submenu__title {
  white-space: normal;
  display: flex;
  align-items: center;
}
.el-menu-item img {
  margin-right: 10px;
  width: 12px;
  height: 12px;
}
.el-icon-share::before {
  display: none;
}
.el-menu-item span{
  display: inline-block;
  line-height: 20px;
  width: calc(100% - 34px);
  color: #666;
}

</style>



// WEBPACK FOOTER //
// src/components/navbar_varieties.vue